import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./scss/style.scss"
import { BrowserRouter } from 'react-router-dom';
const AppWithRender=()=>(
      <BrowserRouter>
        <App />
      </BrowserRouter>
)
ReactDOM.render(<AppWithRender/>,document.getElementById('root'))
reportWebVitals();